import { Download, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import type { CardTabsAttachmentProps } from "./CardTabsLink.types";
import { TruncatedText } from "../../components/TruncatedText/TruncatedText.component";
import { useToolsLinkQuery } from "../../queries";
import { CardResourceStack, TypographyResourceLabel } from "../CardTabsLink/CardResourceStack.styles";

export function CardTabsAttachment({
  dimension,
  disabled,
  id: attachmentId,
  name,
  shortDescription,
  ...props
}: CardTabsAttachmentProps) {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: toolLink } = useToolsLinkQuery({
    enabled: !disabled,
    learningObjectId: id ?? "",
    toolId: attachmentId
  });

  const handleDownload = () => {
    if (!disabled && toolLink?.publicUrl) {
      const link = document.createElement("a");
      link.href = toolLink.publicUrl;
      link.download = "";
      link.target = "_blank";
      link.rel = "noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <CardResourceStack
      tabIndex={ 0 }
      aria-label={ `${t("download_file")} ${name}` }
      { ...props }
      onClick={ handleDownload }
      $disabled={ disabled }
    >
      <FileText
        size={ "1rem" }
      />
      <TruncatedText
        text={ name }
        webkitLineClamp={ 1 }
      >
        <TypographyResourceLabel>
          { name }
        </TypographyResourceLabel>
      </TruncatedText>

      <Download
        size={ "1rem" }
        style={ {
          marginLeft: "auto"
        } }
      />
    </CardResourceStack>
  );
}

// function bytesToMegabytes(bytes: number) {
//   const mb = bytes / 1000000;
//   return `${mb.toFixed(2)} MB`;
// }
